export default __webpack_public_path__ + "static/media/investmentcriteria5.ba144983.jpg";